import request from '@/utils/request'

export function loginByAccount(data) {
	return request({
		url: '/api/common/v1/user/loginByAccount',
		method: 'post',
		data: data,
		headers: {
			isToken: false
		}
	})
}

export function loginByVerificationCode(data) {
	return request({
		url: '/api/common/v1/user/loginByVerificationCode',
		method: 'post',
		data: data,
		headers: {
			isToken: false
		}
	})
}




export function login(username, password, code, uuid) {
	const data = {
		username,
		password,
		code,
		uuid
	}
	return request({
		url: '/login',
		method: 'post',
		data: data
	})
}

export function registerUserApi(data) {//
	return request({
		url: '/system/user/register',
		method: 'post',
		data: data
	})
}

export function getsmsCodeApi(data) {
	return request({
		url: '/getSmsCode',
		method: 'post',
		data
	})
}

export function checkUserNameUnique(data) {//registerUserApi
	return request({
		url: '/system/user/checkUserNameUnique',
		method: 'post',
		data: data
	})
}

export function checkImageCodeApi(data) {
	return request({
		url: '/checkImageCode',
		method: 'post',
		data
	})
}

export function accountLoginApi(data) {
	return request({
		url: '/login/user',
		method: 'post',
		data
	})
}

export function msgLoginApi(data) {
	return request({
		url: '/login/sms',
		method: 'post',
		data
	})
}

export function ukeyLoginApi(data) {
	return request({
		url: '/login/key',
		method: 'post',
		data
	})
}
export function loginByKey(data) {
	return request({
		url: '/loginByKey',
		method: 'post',
		data
	})
}

export function logout() {
	return request({
		url: '/myLogout',
		method: 'post'
	})
}

export function autoLoginByTokenApi(params) {
	return request({
		url: '/login/autoLoginByToken',
		method: 'get',
		params
	});
}
export function getSmsCodeForLoginApi(data) {
	return request({
		url: '/getSmsCodeForLogin',
		method: 'post',
		data
	})
}

export function loginBySmsCodeApi(data) {
	return request({
		url: '/loginBySmsCode',
		method: 'post',
		data
	})
}

export function loginForUserNameAndPhoneApi(data) {
	return request({
		url: '/loginForUserNameAndPhone',
		method: 'post',
		data
	})
}
